import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Header Component
 */
let ResetPasswordComponent = class ResetPasswordComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.data = {};
        this.isError = false;
        this.isChanged = false;
        this.errorMessage = '';
        this.successMessage = '';
        this.emailEntryError = false;
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.successColor = '';
        this.logo = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.logo = this.themeService.getStyleAttribute('logo_image');
            if (this.logo === '' || this.logo === ' ' || this.logo === null) {
                this.logo = 'assets/img/logo-not-found.png';
            }
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    validateEmail(email) {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(email) === false) {
            return false;
        }
        return true;
    }
    close() {
        this.modal.destroy();
    }
    keyEnter(event) {
        if (event.keyCode == 13) {
            this.resetPass();
        }
    }
    resetPass() {
        if (!this.validateEmail(this.data.email)) {
            this.emailEntryError = true;
        }
        else {
            this.httpClient.post('user/resetpassword', this.data).subscribe((success) => {
                this.isChanged = true;
                this.successMessage = success['message'];
            }, (error) => {
                this.isChanged = true;
                if (error.status === 400) {
                    this.errorMessage = error.error['message'];
                }
                else if (error.status === 422) {
                    this.errorEmailMessage = error.email.length;
                }
            });
        }
    }
};
ResetPasswordComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ResetPasswordComponent = __decorate([
    Component({
        selector: 'ecd-reset-password',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./reset-password.component.html")).default
    })
], ResetPasswordComponent);
export { ResetPasswordComponent };
